<template src="../../assets/views/templates/vendas/vendas.html"></template>

<style>
@import "../../assets/views/styles/Vendas.css";
</style>

<script>
import Datepicker from "vuejs-datepicker";
import Loading from "vue-loading-overlay";
import moment from "moment";
import { ptBR } from "vuejs-datepicker/dist/locale";
import VendasInfo from "./VendasInfo";

import {
  dateFormatter,
  changeInitialDate,
  changeFinalDate,
  cnpjFormatter,
} from "../../assets/views/functions";

import {
  onClassChange,
  applyStyle,
  tryCallSalesApi,
  STATUS,
  onChange,
  onChangeInitialDate,
  onChangeEndDate,
  infinitePagination,
} from "../../assets/views/scripts/vendas/sales_functions";

export default {
  components: {
    Datepicker,
    Loading,
    VendasInfo,
  },
  data: () => {
    return {
      dataInicial: null,
      dataFinal: null,
      disabledDatesStart: null,
      disabledDatesEnd: null,
      ptBR: ptBR,
      page: 1,
      status: STATUS.TODOS.id,
      totalSales: 0,
      qtySales: 0,
      avgTicket: 0,
      cnpj: cnpjFormatter(localStorage.getItem("cnpj")),
      options: [
        {
          value: STATUS.CANCELADO.id,
          text: STATUS.CANCELADO.description,
        },
        {
          value: STATUS.CONCRETIZADO.id,
          text: STATUS.CONCRETIZADO.description,
        },
        {
          value: STATUS.TODOS.id,
          text: STATUS.TODOS.description,
        },
      ],
      fields: [
        {
          key: "date",
          sortable: true,
          label: "Data",
          tdClass: "nowrap",
        },
        {
          key: "number",
          label: "Número",
          tdClass: "nowrap",
        },
        {
          key: "clientName",
          label: "Cliente",
          tdClass: "nowrap",
        },
        {
          key: "orderTotalValue",
          label: "Valor Total(R$)",
          tdClass: "nowrap",
        },
        {
          key: "taxPercentValue",
          label: "Taxa(%)",
          tdClass: "nowrap",
        },
        {
          key: "toPay",
          label: "Pagar(R$)",
          tdClass: "nowrap",
        },
        {
          key: "status",
          sortable: true,
          label: "Status",
          tdClass: "nowrap",
        },
        {
          key: "paymentDate",
          label: "Data Faturamento",
          tdClass: "nowrap",
        },
      ],
      items: [],
      series: [],
    };
  },
  methods: {
    dateFormatter,
    changeInitialDate,
    changeFinalDate,
    onClassChange,
    applyStyle,
    tryCallSalesApi,
    onChange,
    onChangeInitialDate,
    onChangeEndDate,
    infinitePagination,
  },
  async mounted() {
    this.observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        const newValue = m.target.getAttribute(m.attributeName);

        this.$nextTick(() => this.onClassChange(newValue, m.oldValue));
      }
    });

    this.observer.observe(document.querySelector("body"), {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ["class"],
    });

    await this.infinitePagination();

    const salesApiResponse = await tryCallSalesApi(
      this.cnpj,
      this.dataInicial,
      this.dataFinal,
      this.page,
      this.status.toString(),
      this.items
    );

    this.items = salesApiResponse.items;
    this.series = salesApiResponse.status;
    this.avgTicket = salesApiResponse.avgTickeg;
    this.qtySales = salesApiResponse.qtySales;
    this.totalSales = salesApiResponse.totalSales;
  },
  async beforeMount() {
    this.dataInicial = moment().startOf("month").format("YYYY-MM-DD 00:00");
    this.dataFinal = new moment().add(1, "months").date(1).format("YYYY-MM-DD 23:59");

    this.disabledDatesStart = new Object();
    this.disabledDatesStart.from = new Date(this.dataFinal);

    this.disabledDatesEnd = new Object();
    this.disabledDatesEnd.to = new Date(this.dataInicial);
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
};
</script>
